module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"root":"styled-system","commonjs2":"styled-system","commonjs":"styled-system","amd":"styled-system"}
// module id = 3
// module chunks = 0